/* eslint-disable no-mixed-spaces-and-tabs */
import { API } from 'aws-amplify';

export function getWebinarDetals(id)
{
	return new Promise((resolve, reject) =>
	{
		API.get('webinars', `/getSingleWebinar/${id}`)
			.then((res) =>
			{
				resolve(res);
			})
			.catch((err) =>
			{
				reject(err);
			});
	});
}

export function createRegister(body)
{
	return new Promise((resolve, reject) =>
	{
		API.post('webinars', '/createRegister', { body })
			.then((res) =>
			{
				resolve(res);
			})
			.catch((err) =>
			{
				reject(err);
			});
	});
}

export function createSurvey(body)
{
	return new Promise((resolve, reject) =>
	{
		API.post('webinars', '/createSurvey', { body })
			.then((res) =>
			{
				resolve(res);
			})
			.catch((err) =>
			{
				reject(err);
			});
	});
}

export function getSpeakers(id)
{
	return new Promise((resolve, reject) =>
	{
		API.get('webinars', `/speaker/${id}`)
			.then((res) =>
			{
				resolve(res);
			})
			.catch((err) =>
			{
				reject(err);
			});
	});
}

export function getSurveyQuestions(id)
{
	return new Promise((resolve, reject) =>
	{
		API.get('webinars', `/getSurvey/${id}`)
			.then((res) =>
			{
				resolve(res);
			})
			.catch((err) =>
			{
				reject(err);
			});
	});
}

export function delSurveyQuestions(id)
{
	return new Promise((resolve, reject) =>
	{
		API.del('webinars', `/deleteSurvey/${id}`)
			.then((res) =>
			{
				resolve(res);
			})
			.catch((err) =>
			{
				reject(err);
			});
	});
}

export function submitSurvey(body)
{
	return new Promise((resolve, reject) =>
	{
		API.post('webinars', '/submitSurvey', { body })
			.then((res) =>
			{
				resolve(res);
			})
			.catch((err) =>
			{
				reject(err);
			});
	});
}

export function getMediaDetails(id, checkVal)
{
	return new Promise((resolve, reject) =>
	{
		API.get('webinars', `/getMediaDetails/${id}?check=${checkVal}`)
			.then((res) =>
			{
				resolve(res);
			})
			.catch((err) =>
			{
				reject(err);
			});
	});
}